<script setup>
import { ref } from 'vue';

const showMenuId = ref(-1);

const toggleMenu = (Id) => {
  showMenuId.value = showMenuId.value === Id ? -1 : Id;
};

const hideMenu = () => {
  showMenuId.value = -1;
};
</script>

<template>
  <div>
    <slot
      name="content"
      :showMenuId="showMenuId"
      :hideMenu="hideMenu"
      :toggleMenu="toggleMenu"
    ></slot>
  </div>
</template>
